/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';
import { Tag } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import Logo from './Logo.svg';
import { CStandardInput } from '../../component/Input';
import InnerHeader from '../../component/InnerHeader';
import { getAllDelivery, setDeliveryDraft, saveDelivery } from '../../actions/deliveryAction';
import { DefaultSelect } from '../../component/Select';

const useStyles = makeStyles({
  actions: {
    display: 'flex'
  },
  currency: {
    color: '#9BA0AD',
    marginLeft: '118px'
  },
  editCurrency: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: '115px'
  },
  img: {
    height: '32px',
    width: '32px'
  },
  infoDiv: {
    alignItems: 'center',
    display: 'flex'
  },
  lastParentDiv: {
    alignItems: 'center',
    borderBottom: '1px solid #F0F4FF',
    borderTop: '1px solid #F0F4FF',
    display: 'flex',
    height: '88px',
    justifyContent: 'space-between'
  },
  name: {
    marginLeft: '28px',
    textAlign: 'start',
    width: '121px'
  },
  parentDiv: {
    alignItems: 'center',
    borderTop: '1px solid #F0F4FF',
    display: 'flex',
    height: '88px',
    justifyContent: 'space-between'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      height: '40px ',
      margin: '0px',
      padding: '14px 16px',
      width: '300px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },

    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    }
  },
  save: {
    background: '#5564F8',
    border: 'none',
    color: 'white',
    marginLeft: '18px'
  },
  tag: {
    alignItems: 'center',
    background: 'white',
    border: '1px solid #CAD8FF',
    borderRadius: '12px',
    cursor: 'pointer',
    display: 'flex',
    fontFamily: 'Poppins',
    fontSize: '14px',
    height: '40px',
    justifyContent: 'center',
    margin: '0px',
    padding: '13px 18px'
  },
  wrapperDiv: {
    padding: '0px 40px 0px 35px'
  }
});

const Users = () => {
  const [edit, setEdit] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  const data = useSelector(({ delivery }) => delivery.deliveries);
  const deliveryDraft = useSelector(({ delivery }) => delivery.deliveriesDraft);

  const selectCurrency = ['₾ GEL', '$ USD', '€ EURO'];
  const currencyLogo = (currency) => {
    switch (currency) {
      case 'GEL':
        return '₾';
      case 'USD':
        return '$';
      case 'EURO':
        return '€';
      default:
        break;
    }
  };

  useEffect(() => {
    const load = async () => {
      dispatch(getAllDelivery());
    };
    load();
  }, [dispatch]);

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: 'calc(100vh - 155px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle="4" title="Delivery" />
      <div className={classes.wrapperDiv}>
        {data.map(({ name, price, currency, _id }, index) => {
          const currencyValue = selectCurrency.filter((selectCurrency) =>
            selectCurrency.includes(deliveryDraft[index]?.currency)
          );

          return (
            <div
              key={_id}
              className={index === data.length - 1 ? classes.lastParentDiv : classes.parentDiv}
            >
              <div className={classes.infoDiv}>
                <img alt="delivery logo" className={classes.img} src={Logo} />
                <div className={classes.name}>{name}</div>
                {edit === index ? (
                  <div className={classes.editCurrency}>
                    <DefaultSelect
                      onSelect={(value) => {
                        const updatedElement = { ...deliveryDraft[index] };
                        updatedElement.currency = value.split(' ')[1];
                        const newDeliveryDraftData = [...deliveryDraft];
                        newDeliveryDraftData[index] = updatedElement;
                        dispatch(setDeliveryDraft(newDeliveryDraftData));
                      }}
                      selectStyles={{ marginRight: '16px', minWidth: '100px', width: '100px' }}
                      value={currencyValue[0]}
                    >
                      {selectCurrency.map((currency) => {
                        return (
                          <MenuItem key={currency} value={currency}>
                            {currency}
                          </MenuItem>
                        );
                      })}
                    </DefaultSelect>
                    <CStandardInput
                      defaultValue={price}
                      disableUnderline
                      formclasses={{ root: classes.root }}
                      htmlFor="standard-input-delivery-price"
                      id="standard-input-delivery-price"
                      onChange={(e) => {
                        const updatedElement = deliveryDraft[index];
                        updatedElement.price = parseInt(e.target.value, 10);
                        deliveryDraft[index] = updatedElement;
                        dispatch(setDeliveryDraft(deliveryDraft));
                      }}
                      size="large"
                      type="number"
                      width="true"
                    />
                  </div>
                ) : (
                  <div className={classes.currency}>
                    {currencyLogo(currency)}
                    {price}
                  </div>
                )}
              </div>
              {edit === index ? (
                <div className={classes.actions}>
                  <Tag className={`${classes.tag} ${classes.cancel}`} onClick={() => setEdit(null)}>
                    Cancel
                  </Tag>
                  <Tag
                    className={`${classes.tag} ${classes.save}`}
                    onClick={() => {
                      dispatch(
                        saveDelivery({
                          body: deliveryDraft[index],
                          id: _id
                        })
                      );
                    }}
                  >
                    Save
                  </Tag>
                </div>
              ) : (
                <Tag className={classes.tag} onClick={() => setEdit(index)}>
                  Edit
                </Tag>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Users;
